import { IconComponentWrapper } from "../scripts/generate-icons/icon-component-wrapper";
import type { IconProps } from "../scripts/generate-icons/ticon-component-wrapper";

function IconComponent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={45}
      height={24}
      viewBox="0 0 45 24"
      fill="none"
      {...props}
    >
      <path
        d="M33.0628 0H12.0537C5.48835 0 0.116699 5.4 0.116699 12C0.116699 18.6 5.48835 24 12.0537 24H33.0628C39.6282 24 44.9998 18.6 44.9998 12C44.9998 5.4 39.6282 0 33.0628 0Z"
        fill="white"
      />
      <path
        d="M33.0628 0.972C34.537 0.972 35.9695 1.266 37.3184 1.842C38.6255 2.4 39.7953 3.198 40.8099 4.212C41.8186 5.226 42.6124 6.408 43.1675 7.722C43.7405 9.078 44.0329 10.518 44.0329 12C44.0329 13.482 43.7405 14.922 43.1675 16.278C42.6124 17.592 41.8186 18.768 40.8099 19.788C39.8013 20.802 38.6255 21.6 37.3184 22.158C35.9695 22.734 34.537 23.028 33.0628 23.028H12.0537C10.5795 23.028 9.14704 22.734 7.79816 22.158C6.49106 21.6 5.32123 20.802 4.30659 19.788C3.29791 18.774 2.5041 17.592 1.94903 16.278C1.37605 14.922 1.0836 13.482 1.0836 12C1.0836 10.518 1.37605 9.078 1.94903 7.722C2.5041 6.408 3.29791 5.232 4.30659 4.212C5.31526 3.198 6.49106 2.4 7.79816 1.842C9.14704 1.266 10.5795 0.972 12.0537 0.972H33.0628ZM33.0628 0H12.0537C5.48835 0 0.116699 5.4 0.116699 12C0.116699 18.6 5.48835 24 12.0537 24H33.0628C39.6282 24 44.9998 18.6 44.9998 12C44.9998 5.4 39.6282 0 33.0628 0Z"
        fill="#3C4043"
      />
      <path
        d="M21.5838 12.8516V16.4816H20.436V7.51758H23.4788C24.25 7.51758 24.9076 7.77558 25.4456 8.29158C25.9956 8.80758 26.2706 9.43758 26.2706 10.1816C26.2706 10.9436 25.9956 11.5736 25.4456 12.0836C24.9136 12.5936 24.256 12.8456 23.4788 12.8456H21.5838V12.8516ZM21.5838 8.62158V11.7476H23.5028C23.9571 11.7476 24.3397 11.5916 24.6386 11.2856C24.9435 10.9796 25.0989 10.6076 25.0989 10.1876C25.0989 9.77358 24.9435 9.40758 24.6386 9.10158C24.3397 8.78358 23.9631 8.62758 23.5028 8.62758H21.5838V8.62158Z"
        fill="#3C4043"
      />
      <path
        d="M29.2717 10.1455C30.1205 10.1455 30.7901 10.3735 31.2803 10.8295C31.7705 11.2855 32.0156 11.9095 32.0156 12.7015V16.4815H30.9216V15.6295H30.8738C30.4015 16.3315 29.7678 16.6795 28.9787 16.6795C28.3032 16.6795 27.7413 16.4815 27.287 16.0795C26.8326 15.6775 26.6055 15.1795 26.6055 14.5795C26.6055 13.9435 26.8446 13.4395 27.3228 13.0675C27.8011 12.6895 28.4407 12.5035 29.2358 12.5035C29.9173 12.5035 30.4792 12.6295 30.9156 12.8815V12.6175C30.9156 12.2155 30.7602 11.8795 30.4434 11.5975C30.1265 11.3155 29.7559 11.1775 29.3314 11.1775C28.6918 11.1775 28.1837 11.4475 27.813 11.9935L26.8027 11.3575C27.3587 10.5475 28.1837 10.1455 29.2717 10.1455ZM27.7891 14.5975C27.7891 14.8975 27.9147 15.1495 28.1717 15.3475C28.4228 15.5455 28.7217 15.6475 29.0624 15.6475C29.5467 15.6475 29.9771 15.4675 30.3537 15.1075C30.7303 14.7475 30.9216 14.3275 30.9216 13.8415C30.5629 13.5595 30.0667 13.4155 29.4271 13.4155C28.9608 13.4155 28.5722 13.5295 28.2614 13.7515C27.9445 13.9855 27.7891 14.2675 27.7891 14.5975Z"
        fill="#3C4043"
      />
      <path
        d="M38.2565 10.3438L34.4306 19.1758H33.2469L34.6697 16.0858L32.147 10.3438H33.3964L35.2137 14.7477H35.2376L37.0071 10.3438H38.2565Z"
        fill="#3C4043"
      />
      <path
        d="M17.0186 12.1197C17.0186 11.7441 16.9851 11.3847 16.9229 11.0391H12.1118V13.0191L14.8826 13.0197C14.7702 13.6785 14.4086 14.2401 13.8544 14.6145V15.8991H15.5037C16.4668 15.0045 17.0186 13.6821 17.0186 12.1197Z"
        fill="#4285F4"
      />
      <path
        d="M13.8549 14.6144C13.3958 14.9252 12.8046 15.107 12.1129 15.107C10.7768 15.107 9.64338 14.2034 9.23748 12.9854H7.53613V14.3102C8.37903 15.989 10.1115 17.141 12.1129 17.141C13.4962 17.141 14.6583 16.6844 15.5042 15.8984L13.8549 14.6144Z"
        fill="#34A853"
      />
      <path
        d="M9.07743 12.0025C9.07743 11.6605 9.13422 11.3299 9.23764 11.0191V9.69434H7.5363C7.18778 10.3885 6.9917 11.1721 6.9917 12.0025C6.9917 12.8329 7.18838 13.6165 7.5363 14.3107L9.23764 12.9859C9.13422 12.6751 9.07743 12.3445 9.07743 12.0025Z"
        fill="#FABB05"
      />
      <path
        d="M12.1129 8.89777C12.8679 8.89777 13.544 9.15877 14.0779 9.66877L15.5395 8.20297C14.6518 7.37317 13.4944 6.86377 12.1129 6.86377C10.1121 6.86377 8.37903 8.01577 7.53613 9.69457L9.23748 11.0194C9.64338 9.80137 10.7768 8.89777 12.1129 8.89777Z"
        fill="#E94235"
      />
    </svg>
  );
}
const IconComponentWrapped = (props: IconProps) => {
  return (
    <IconComponentWrapper data-testid="icon-google-pay-mark" {...props}>
      <IconComponent />
    </IconComponentWrapper>
  );
};
export default IconComponentWrapped;
